module.exports = __webpack_public_path__ + "img/ch15_02_小巷挡身.84337dcc.png";